// --- Accordionクラスの使い方メモ ---
//
// 1. HTML構造例
// <details class="my-accordion">
//   <summary class="my-trigger">タイトル</summary>
//   <div class="my-content">コンテンツ</div>
// </details>
//
// 2. JSで初期化
// document.addEventListener("DOMContentLoaded", () => {
//   new Accordion("my-accordion", "my-trigger", "my-content", 400, "ease-out");
// });

class Accordion
{
  constructor (
    detailsClass,
    summaryClass,
    contentClass,
    duration = 400,
    easing = "ease-out"
  )
  {
    this.detailsClass = detailsClass;
    this.summaryClass = summaryClass;
    this.contentClass = contentClass;
    this.duration = duration;
    this.easing = easing;
    this.RUNNING_VALUE = "running";
    this.IS_OPENED_CLASS = "is-opened";
    this.animTiming = {
      duration: this.duration,
      easing: this.easing,
    };
    this.init();
  }

  // 対象クラスが付いた<details>要素すべてに開閉処理をセットアップする
  init ()
  {
    const detailsList = document.querySelectorAll( `.${ this.detailsClass }` );
    detailsList.forEach( ( element ) => this.setUpAccordion( element ) );
  }

  // 1つの<details>要素に対して、クリックでアニメーションしながら開閉するようにする
  setUpAccordion ( element )
  {
    const summary = element.querySelector( `.${ this.summaryClass }` );
    const content = element.querySelector( `.${ this.contentClass }` );
    if ( !summary || !content ) return;

    summary.addEventListener( "click", ( event ) =>
    {
      event.preventDefault();
      if ( element.dataset.animStatus === this.RUNNING_VALUE ) return;

      if ( element.open )
      {
        const closingAnim = content.animate(
          this.closingAnimKeyframes( content ),
          this.animTiming
        );
        element.dataset.animStatus = this.RUNNING_VALUE;
        closingAnim.onfinish = () =>
        {
          element.removeAttribute( "open" );
          element.classList.remove( this.IS_OPENED_CLASS );
          element.dataset.animStatus = "";
        };
      } else
      {
        element.setAttribute( "open", "true" );
        element.classList.add( this.IS_OPENED_CLASS );
        const openingAnim = content.animate(
          this.openingAnimKeyframes( content ),
          this.animTiming
        );
        element.dataset.animStatus = this.RUNNING_VALUE;
        openingAnim.onfinish = () =>
        {
          element.dataset.animStatus = "";
        };
      }
    } );
  }

  // 閉じるアニメーション用のキーフレーム(現在の高さ→0)
  closingAnimKeyframes ( content )
  {
    return [
      {
        height: content.offsetHeight + "px",
        opacity: 1,
      },
      {
        height: 0,
        opacity: 0,
      },
    ];
  }

  // 開くアニメーション用のキーフレーム(0→開いた時の高さ)
  // 一度"auto"にして実際の高さを測ってから戻す(高さが可変のコンテンツでも正しくアニメーションさせるため)
  openingAnimKeyframes ( content )
  {
    content.style.height = "auto";
    const endHeight = content.offsetHeight;
    content.style.height = "";
    return [
      {
        height: 0,
        opacity: 0,
      },
      {
        height: endHeight + "px",
        opacity: 1,
      },
    ];
  }
}

export default Accordion;
